/** Eenmalige contextpaneel-intro in Inbox (contextIntro), na inboxIntro, alleen desktop. */
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  ONBOARDING_HINT_CONTEXT_INTRO,
  ONBOARDING_HINT_INBOX_INTRO,
} from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import {
  isDesktopBreakpoint,
  useBreakpoint,
} from '@/hooks/ui/useBreakpoint';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.isContextPanelOpen
 * @param {string | undefined} params.userId
 */
export function useContextIntroHint({ isContextPanelOpen, userId }) {
  const breakpoint = useBreakpoint();
  const isDesktop = isDesktopBreakpoint(breakpoint);
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (initRef.current) {
      return;
    }
    if (
      !isContextPanelOpen ||
      !userId ||
      !profileLoaded ||
      !isDesktop ||
      !seenHints.includes(ONBOARDING_HINT_INBOX_INTRO)
    ) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_CONTEXT_INTRO)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_CONTEXT_INTRO);
  }, [
    isContextPanelOpen,
    userId,
    profileLoaded,
    seenHints,
    isDesktop,
  ]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
